import { HttpRequest, HttpRequestLog } from './HttpRequest'

export const Search = async (objectSearch: any) => {
    let data = JSON.stringify(objectSearch);
    try {
        const response = await HttpRequest().post(`/planning/pj/transfer/search`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'OK') {
            return response.data.responseData
        }
    } catch (error: any) {
        if (error.response.status === 400) return error.response.data.message

        throw new Error('ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่')
    }
}

export const save = async (objectSearch: any) => {
    let data = JSON.stringify(objectSearch);
    try {
        const response = await HttpRequest().post(`/planning/pj/transfer/save`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        
        return response.data.message

    } catch (error: any) {
        if (error.response.status === 400) return error.response.data.message
        throw new Error('error api /planning/pj/transfer/save')
    }
}

export const addLog =  (objectSearch: any) => {
    let data = JSON.stringify(objectSearch);
    try {
        const response = HttpRequestLog().post(`/jsondata/addlog`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })

    } catch (error: any) {
        if (error.response.status === 400) return error.response.data.message
        throw new Error('Error add Log api' + error.response.data.message)
    }
}


export interface ISearch {
    unitId: number
    unitCode: string
    bookingId: number
    signId: number
    transferId: number
    prospectId: number
    flagActiveSign: boolean
    saleStatus: string
    address: string
    model: string
    area: number
    areaValue: number
    customerName: string
    mobilePhone: string
    email: string
    inspectionAfterTransferDate: string
    planPJAfterTransferDate: string
    transferStatus: string
    letterPlanforCR: string
    inspection1Id: number
    inspection1PlanPJDate: string
    inspection1FinishPJDate: string
    inspection1PlanCRDate: string
    inspection1PlanCRTime: string
    inspection1CustomerDate: string
    inspection1TypeID: number
    inspection2Id: number
    inspection2PlanPJDate: string
    inspection2FinishPJDate: string
    inspection2PlanCRDate: string
    inspection2PlanCRTime: string
    inspection2CustomerDate: string
    inspection2TypeID: number
    inspection3Id: number
    inspection3PlanPJDate: string
    inspection3FinishPJDate: string
    inspection3PlanCRDate: string
    inspection3PlanCRTime: string
    inspection3CustomerDate: string
    inspection3TypeID: number
    inspection4Id: number
    inspection4PlanPJDate: string
    inspection4FinishPJDate: string
    inspection4PlanCRDate: string
    inspection4PlanCRTime: string
    inspection4CustomerDate: string
    inspection4TypeID: number
    crNote: string
    pjNote: string
    finalCRPlanDate: string
    finalCRPlanTime: string
    finalInspection: number
    customerTransferReal: string
    csPlanDate: string
    transferActDate: string
    finalActualDate: string
    signActivityId: number
    attachedFile: number
    crName: string
    crId: number
    vipStatus: string
    contractUnitPrice: number
    netPrice: number
    transferPlanTypeId: number
    flagInspectorContractor:boolean
    inspectorName:string
    pjCode:string

}